<script setup lang="ts">
import type { IProps } from './DataViewEmptyState.types'
defineProps<IProps>()
</script>

<template>
  <div class="dataViewEmptyState">
    <img
      class="dataViewEmptyState__icon"
      src="/icons/no-results.svg"
      :alt="text"
      width="64"
      height="64"
    >

    <p class="dataViewEmptyState__text">
      {{ text || $t('common.dataView.empty') }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
.dataViewEmptyState {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.6rem;

  &__text {
    @include h8;
    color: $text-300;
    text-align: center;
  }
}
</style>
